(function () {
  "use strict";

  var header = document.querySelector(
    "#top-nav[data-shared-header]"
  );

  if (!header) return;


  function updateHeader() {

  var announcementBar = document.querySelector(
    ".elore-announcement-bar"
  );

  var announcementHeight = announcementBar
    ? announcementBar.offsetHeight
    : 0;

  if (window.scrollY > 20) {

    header.classList.add("scrolled");

    header.style.top = "0px";

  } else {

    header.classList.remove("scrolled");

    header.style.top = announcementHeight + "px";

  }

}


  updateHeader();


  window.addEventListener(
    "scroll",
    updateHeader,
    { passive: true }
  );


  /* =====================================================
     FULLSCREEN MENU
     ===================================================== */

  var menu = document.getElementById("elore-menu");

  var menuToggle = document.querySelector(
    "[data-elore-menu-toggle]"
  );

  var closeButtons = document.querySelectorAll(
    "[data-elore-menu-close]"
  );

  var menuLinks = document.querySelectorAll(
    "[data-elore-menu-link]"
  );
  var searchToggle = document.querySelector(
  "[data-elore-search-toggle]"
);

if (searchToggle) {
  searchToggle.addEventListener("click", function () {
    window.location.href = "/search";
  });
}


  if (!menu || !menuToggle) return;


  function openMenu() {

    menu.classList.add("is-open");

    menu.setAttribute(
      "aria-hidden",
      "false"
    );

    document.body.style.overflow = "hidden";

  }


  function closeMenu() {

    menu.classList.remove("is-open");

    menu.setAttribute(
      "aria-hidden",
      "true"
    );

    document.body.style.overflow = "";

  }


  menuToggle.addEventListener(
    "click",
    function () {

      if (
        menu.classList.contains("is-open")
      ) {
        closeMenu();
      } else {
        openMenu();
      }

    }
  );


  closeButtons.forEach(function (button) {

    button.addEventListener(
      "click",
      closeMenu
    );

  });


  menuLinks.forEach(function (link) {

    link.addEventListener(
      "click",
      closeMenu
    );

  });


  document.addEventListener(
    "keydown",
    function (event) {

      if (event.key === "Escape") {
        closeMenu();
      }

    }
  );

})();
/* =========================================================
   ELORE MENU — SHOP BY TABS
   ========================================================= */

(function () {
  "use strict";

  var tabs = document.querySelectorAll("[data-menu-tab]");
  var panels = {
    categories: document.getElementById("menu-panel-categories"),
    occasion: document.getElementById("menu-panel-occasion")
  };

  if (!tabs.length) return;

  tabs.forEach(function (tab) {

    tab.addEventListener("click", function () {

      var target = tab.getAttribute("data-menu-tab");

      tabs.forEach(function (item) {
        var isActive =
          item.getAttribute("data-menu-tab") === target;

        item.classList.toggle("active", isActive);
        item.setAttribute(
          "aria-selected",
          isActive ? "true" : "false"
        );
      });


      Object.keys(panels).forEach(function (key) {

        if (!panels[key]) return;

        panels[key].classList.toggle(
          "hidden",
          key !== target
        );

      });

    });

  });

})();